import React from 'react'
import './ImageStyleSheet.css';

function RogerOne() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/roger1.jpeg" className='img-view'/>
        </div>
    )
}

export default RogerOne
